<template>
    <v-app pb-3>
        <v-content>
            <v-form>
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <v-layout row wrap>
                        <v-flex xs12 md10>
                            <h1>Личный кабинет</h1>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-container style="max-width: 1200px;">
                    <v-layout wrap row>
                        <v-flex
                            class="service-item"
                            xs12 sm6 v-for="(service, key) in services"
                            :key="key"
                            v-show="service.show"
                        >
                            <span v-if="service.count" class="kbm-badge">{{service.count}}</span>
                            <img
                                class="kbm-image"
                                v-if="service.img"
                                :src="service.img"
                                :href="service.link"
                            />
                            <a class="service-link"
                               :href="service.link"
                               v-html="service.name"/>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
export default {
    props: [
        'newAgents',
        'isAdmin',
    ],
    created() {
        this.services = [
            {
                name: 'Все пользователи',
                link: '/agents',
                count: this.newAgents,
                img: '/svg/men.svg',
                show: true,
            },
            {
                name: 'Страховые продукты',
                link: '/list',
                img: '/svg/list.svg',
                show: true,
            },
            {
                name: 'Банковские продукты',
                link: '/bp/list',
                show: this.isAdmin,
            },
            {
                name: 'Баланс',
                link: '/accounting-list',
                show: true,
            },
            {
                name: 'Вознаграждение',
                link: '/commissions',
                img: '/svg/persent.svg',
                show: true,
            },
            {
                name: 'Сегментация',
                link: '/segmentations',
                show: this.isAdmin,
            },
            {
                name: 'Настройки Е-Гарант',
                link: '/egarant-companies',
                show: this.isAdmin,
            },
            {
                name: 'Сервисы',
                link: '/b2b-services',
                show: true,
            },
            {
                name: 'Профиль',
                link: '/profile',
                img: 'https://static.tildacdn.com/tild3863-6264-4161-b031-393634366239/man.svg',
                show: true,
            },
            {
                name: 'Руководство по сайту',
                link: '/guide/produktovaya-lineyka',
                show: true,
            },
        ]
    },
    data: () => ({
        services: []
    })
}
</script>

<style scoped>

/deep/ h1 {
    font-size: 65px;
    font-family: 'SFUIDisplay', Arial, sans-serif;
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

/deep/ h2, h3 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}
.service-item {
    width: 100%;
    position: relative;
}

.service-link {
    display: block;
    background-color: #f1f2f3;
    border-radius: 12px;
    width: 100%;
    height: 100%;
    color: black;
    text-decoration: none;
    font-family: 'SFUIDisplay', Arial, sans-serif;
    font-size: 26px;
    padding: 20px;
}

.kbm-badge {
    font-family: 'SFPro';
    font-weight: 700;
    font-size: 14px;
    color: #fff !important;
    background: #00ba57;
    border-radius: 50%;
    max-width: 32px;
    max-height: 32px;
    min-width: 32px;
    min-height: 32px;
    width: 32px;
    height: 32px;
    padding: 6px;
    text-align: center;
    vertical-align: middle;
    display: table-cell;
    position: absolute;
    right: 20px;
    cursor: pointer;
}

.kbm-image {
    position: absolute;
    width: 48px;
    height: 48px;
    text-align: center;
    vertical-align: middle;
    display: table-cell;
    position: absolute;
    right: 30px;
    cursor: pointer;
}


@media (min-width: 600px) {
    .service-item {
        height: 250px;
    }

    .kbm-badge {
        top: 32px;
    }

    .kbm-image {
        top: 180px;
    }
}

.service-item:hover {
    -webkit-filter: brightness(95%);
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    -ms-transition: all 0.5s ease;
    transition: all 0.5s ease;
}

@media (max-width: 959px) {
    h1 {
        font-size: 50px;
    }
}

@media (max-width: 639px) {
    .service-link {
        font-size: 18px;
    }

}

@media (max-width: 599px) {
    .kbm-badge {
        top: 24px;
    }

    .kbm-image {
        width: 24px;
        height: 24px;
        top: 28px;
    }

    .kbm-image:nth-child(2) {
        display: none;
    }

    .service-link {
        padding: 16px 20px;
    }

    h1 {
        font-size: 30px;
    }
}

@media (max-width: 479px) {
}

</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/DashboardAdmin.vue